import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import View from "./View";
import { requestClubs } from "../../modules/club/actions";

function mapStateToProps(state) {
    return {
        clubs: state.clubs
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            requestClubs
        },
        dispatch
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(View);



// WEBPACK FOOTER //
// ./src/routes/States/index.js